import { defineStore } from 'pinia'
import { HttpClient } from '@/http/httpClient'
const http = new HttpClient()

interface Config {
  cardDisplayCount: number // 帖子详情页初始推荐卡片露出个数
  guideAwardImageList: string[] // 新手引导奖励图片列表
  feSettings: {
    [key: string]: any
  }
  feedBannerList: Array<{
    banner_id: string
    banner_image_url: string
    link_url: string
    start_time: string
    end_time: string
  }> // 首页banner列表
}

interface RequestOptions {
  retry: number
}
const maxRetry = 3

export const useGlobalConfigStore = defineStore('globalConfig', {
  state: (): Config => ({
    cardDisplayCount: 3, // 只有本地没有持久化的时候兜底值才会生效
    guideAwardImageList: [],
    feedBannerList: [],
    feSettings: {}
  }),
  getters: {
    // activeFeedBannerList: state =>
    //   state.feedBannerList.filter(item => {
    //     const endTime = new Date(item.end_time.replace(/-/g, '/')).getTime()
    //     const startTime = new Date(item.start_time.replace(/-/g, '/')).getTime()
    //     return Date.now() >= startTime && Date.now() <= endTime
    //   })
  },
  actions: {
    async fetchConfig(opt: RequestOptions = { retry: maxRetry }) {
      try {
        const resultList = await Promise.allSettled([
          http.get('/aigc/api/fe-settings/pc', {}, opt),
          http.get(
            '/aigc/api/activity/want-it/guide',
            {},
            {
              isShowErrorModal: false
            }
          )
        ])
        if (resultList[0].status === 'fulfilled') {
          this.cardDisplayCount = resultList[0].value.data.cardDisplayCount
          this.feSettings = resultList[0].value.data
        }
        if (resultList[1].status === 'fulfilled') {
          this.guideAwardImageList = resultList[1].value.data.productImage
        }
      } catch (err) {
        // empty
      }
    }
  },
  persist: true // 开启持久化
})
